import { render } from "./AiTeaching.vue?vue&type=template&id=3af5737a&scoped=true"
import script from "./AiTeaching.vue?vue&type=script&lang=js"
export * from "./AiTeaching.vue?vue&type=script&lang=js"

import "./AiTeaching.vue?vue&type=style&index=0&id=3af5737a&scoped=true&lang=scss"
import "./AiTeaching.vue?vue&type=style&index=1&id=3af5737a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af5737a"]])

export default __exports__